import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { NotificationType } from 'src/@smartmanufacturing/common/enum';
import { BaseApi } from '../api/base-api';
import { NotificationItem } from '../models/notifications/notification-item';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    public notification$ = new Subject<NotificationItem>();
    public markNotification$ = new Subject<NotificationItem>();
    public notifications = new Subject<Array<any>>();
    public notificationCount$ = new Subject<number>();
    public eof$ = new Subject<boolean>();
    public currentDataLength$ = new Subject<number>();

    constructor(
        private router: Router,
        private baseApi: BaseApi,
        private http: HttpClient,
        private toaster: ToastrService
    ) {
    }

    showNotification(notification: NotificationItem) {
        this.notification$.next(notification);
    }

    navigateToNotificationTarget(notification: NotificationItem) {
        switch (notification?.type) {
            case NotificationType.MULTIPLE_PLANT_REQUEST:
                this.router.navigate(['/user-access/user-management/multiple-plant-requests']);
                break;
            case NotificationType.PLANT_REQUEST_SENT_APPROVE:
                this.router.navigate(['/user-access/user-management/multiple-plant-requests-sent'])
                break;
            case NotificationType.PLANT_REQUEST_SENT_REJECT:
                this.router.navigate(['/user-access/user-management/multiple-plant-requests-sent'])
                break;
            default:
                break;
        }
    }

    getUserNotifications(data: any) {
        let params = '';
        if (data?.pageIndex) {
            params += 'offset=' + data?.pageIndex.toString();
        }
        if (data?.pageSize) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'limit=' + data?.pageSize.toString();
        }
        if (data?.notificationType) {
            if (params.length > 0) {
                params += '&';
            }
            params += `notificationType=` + data?.notificationType;
        }
        if (data?.phrase) {
            if (params.length > 0) {
              params += '&';
            }
            params += 'phrase=' + data?.phrase;
          }
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_NOTIFICATIONS + '?' + params)).subscribe({
            next: (response) => {
                this.notifications.next(response?.data);
                this.notificationCount$.next(response?.totalCount);
                this.eof$.next(response?.data?.length < 10 ? true : false);
                this.currentDataLength$.next(response?.data?.length)
            },
            error: ({ error }) => {
                this.toaster.error('Error', error?.message)
            }
        });
    }
    markAsReadNotification(data: any): Observable<any> {
        return this.http.put<any>(this.baseApi.encodeURL(Constants.API_NOTIFICATION_MARK_AS_READ), data);
    }
    markAllAsReadNotification(data: any[]): Observable<any> {
        return this.http.put<any>(this.baseApi.encodeURL(Constants.API_NOTIFICATIONS_MARK_ALL_AS_READ), data);
    }
}
